export const LABELS_DEVICES = {

    devicesName: "Список ТЗ",
    selectedDevice: "Обрати ТЗ",
    moreSelectDevice: "Розширений вибір ТЗ",
    fields: {
        accountCode: "Перевізник",
        accountName: "Назва перевізника",
        active: "Активний",
        description: "Опис",
        displayName: "Марка об'єкту",
        object: "Об'єкт",
        equipmentType: "Автобус",
        fuelLevel: 0,
        heading: 352,
        id: 120,
        imei: "IMEI",
        lastEventTime: "2023-03-22T12:58:38+02:00",
        lastGPSOdomKM: '230472.31619575637',
        latitude: '49.2524683',
        legacyDeviceId: "BC-3269-AA",
        licensePlate: "Держ.номер",
        longitude: '23.8489066',
        phone: "+380678136026",
        protocolCode: "teltonika",
        sensors: '',
        speed: 'Швидкість',
        uniqueCode: "ID"
    },
}